import React from "react";

const YoutubeBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131569)">
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#E60000"
      />
      <path
        d="M21.235 9.98108H10.7634C10.3449 9.98108 9.93055 10.0635 9.54395 10.2237C9.15736 10.384 8.80613 10.6188 8.51032 10.9148C8.21452 11.2108 7.97994 11.5622 7.81998 11.9489C7.66003 12.3356 7.57785 12.75 7.57813 13.1684V18.8316C7.57785 19.2501 7.66003 19.6645 7.81998 20.0512C7.97994 20.4379 8.21452 20.7893 8.51032 21.0853C8.80613 21.3813 9.15736 21.6161 9.54395 21.7763C9.93055 21.9365 10.3449 22.019 10.7634 22.019H21.235C21.6534 22.019 22.0678 21.9365 22.4544 21.7763C22.841 21.6161 23.1922 21.3813 23.488 21.0853C23.7838 20.7893 24.0184 20.4379 24.1784 20.0512C24.3383 19.6645 24.4205 19.2501 24.4202 18.8316V13.1684C24.4205 12.75 24.3383 12.3356 24.1784 11.9489C24.0184 11.5622 23.7838 11.2108 23.488 10.9148C23.1922 10.6188 22.841 10.384 22.4544 10.2237C22.0678 10.0635 21.6534 9.98108 21.235 9.98108ZM13.7802 18.5811V13.419L18.2181 16L13.7802 18.5811Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131569">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default YoutubeBrand1;
